import { useSyncExternalStore } from "react";

/* Vero se la media query vale. Le pagine e il guscio montano una vista sola per volta (tabella o elenco,
   griglia o agenda): così ogni testid esiste una volta sola. Senza matchMedia (i test) vale «computer». */
export function useMedia(query) {
  return useSyncExternalStore(
    (cambia) => {
      const m = window.matchMedia?.(query);
      m?.addEventListener("change", cambia);
      return () => m?.removeEventListener("change", cambia);
    },
    () => window.matchMedia?.(query).matches ?? true,
  );
}
